import FirebaseUtils from './FirebaseUtils';

export const logUserEvent = (eventMessage) => {
  FirebaseUtils.generateEvent(eventMessage);
};

export const logUserParamEvent = (eventMessage, params) => {
  FirebaseUtils.generateParamEvent(eventMessage, params);
};
